import { AdminCollectionPage } from "../../clay/admin-collection-page";
import { RoleWidget } from "./widget";

export const RolesPage = AdminCollectionPage({
    meta: RoleWidget,
    labelColumn: "name",
    urlPrefix: "#/admin/roles",
});
